export default "__VITE_ASSET__DEIAXk2n__"